import { call, put, takeEvery } from "redux-saga/effects";
import {
  getCampaignOfferTypesList,
  hideCampaignOfferTypesListLoader,
  setCampaignOfferTypeProfile,
  setCampaignOfferTypesList,
  setErrorCampaignOfferTypeProfile,
  showCampaignOfferTypesListLoader
} from "./actions";
import {
  ADD_CAMPAIGN_OFFER_TYPES,
  DELETE_CAMPAIGN_OFFER_TYPES,
  GET_CAMPAIGN_OFFER_TYPE_PROFILE,
  GET_CAMPAIGN_OFFER_TYPES_LIST,
  UPDATE_CAMPAIGN_OFFER_TYPE_PROFILE
} from "./actionTypes";
import {
  deleteCampaignOfferType,
  getCampaignOfferTypeParams,
  getCampaignOfferTypeProfile,
  postCampaignOfferType,
  putCampaignOfferTypeProfile
} from "../../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../../helpers/utils";

// Chat Redux States
function* onGetCampaignOfferTypeList({ payload: data }) {
  try {
    yield put(showCampaignOfferTypesListLoader());
    let response = yield call(getCampaignOfferTypeParams, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({ ...i, description: i.description === "string" ? "" : i.description }))
    };
    yield put(setCampaignOfferTypesList(response));
    yield put(hideCampaignOfferTypesListLoader());
  } catch (error) {
    yield put(hideCampaignOfferTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignOfferType({ payload: {offerType, data } }) {
  try {
    yield put(showCampaignOfferTypesListLoader());
    yield call(postCampaignOfferType, {
      name: offerType.name,
      description: offerType.description
    });
    yield call(onGetCampaignOfferTypeList, { payload: data });
    yield put(hideCampaignOfferTypesListLoader());
    showSuccessMessage("Campaign offer type has been added");
  } catch (error) {
    yield put(hideCampaignOfferTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteOfferType({ payload: { id, data } }) {
  try {
    yield put(showCampaignOfferTypesListLoader());
    yield call(deleteCampaignOfferType, id);
    yield call(onGetCampaignOfferTypeList, { payload: data });
    yield put(hideCampaignOfferTypesListLoader());
    showSuccessMessage("Campaign offer type has been deleted");
  } catch (error) {
    yield put(hideCampaignOfferTypesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignOfferTypeProfile({ payload: id }) {
  try {
    yield put(setErrorCampaignOfferTypeProfile(false));
    let response = yield call(getCampaignOfferTypeProfile, id);
    yield put(setCampaignOfferTypeProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === 'Not found.') {
      yield put(setErrorCampaignOfferTypeProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdateCampaignOfferTypeProfile({ payload: {id, offerType, data } }) {
  try {
    yield put(showCampaignOfferTypesListLoader());
    yield call(putCampaignOfferTypeProfile, id, {
      name: offerType.name,
      description: offerType.description
    });
    yield call(onGetCampaignOfferTypeList, { payload: data });
    yield put(hideCampaignOfferTypesListLoader());
    showSuccessMessage("Campaign offer type has been updated");
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignOfferTypeListSaga() {
  yield takeEvery(GET_CAMPAIGN_OFFER_TYPES_LIST, onGetCampaignOfferTypeList);
  yield takeEvery(DELETE_CAMPAIGN_OFFER_TYPES, onDeleteOfferType);
  yield takeEvery(ADD_CAMPAIGN_OFFER_TYPES, onAddCampaignOfferType);
  yield takeEvery(GET_CAMPAIGN_OFFER_TYPE_PROFILE, onGetCampaignOfferTypeProfile);
  yield takeEvery(UPDATE_CAMPAIGN_OFFER_TYPE_PROFILE, onUpdateCampaignOfferTypeProfile);
}

export default campaignOfferTypeListSaga;
